export default function initSearchWidget () {
  const container = $('#searchWidget');
  var search,
    SearchWidget = {

      settings: {
        item: $('li', container),
        input: $('input', container),
        select: $('select', container),
        btn: $('button', container)
      },

      init: function () {
        search = this.settings;
        this.switchSearchTypes();
        this.showSearchResults();
      },

      switchSearchTypes: function () {
        search.item.on('click', function (e) {
          search.link = $(this).find('a');
          search.type = search.link.attr('data-type');
          search.input.attr('placeholder', 'All' + ' ' + search.type);
          search.item.removeClass('active');
          $(this).addClass('active');
          e.preventDefault();
        });
      },

      showSearchResults: function () {
        const redirectToList = function () {
          search.activeItem = $('.active a', container);
          search.url = search.activeItem.attr('data-url');
          search.value = search.input.val();
          search.city = search.select.val();
          window.location = '/' + search.url + '/?q=' + search.value + '&city[0]=' + search.city
        };

        search.btn.on('click', function () {
          redirectToList();
        });

        search.input.keypress(function (e) {
          const keyCode = e.keyCode || e.which;
          if (keyCode === 13) {
            redirectToList();
          }
        });
      }
    }.init();
}



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/home/searchWidget.js